import React, {Fragment} from 'react';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './PasswordInput.styles';
import PasswordShowInput from './PasswordShowInput';


class PasswordInput extends React.Component {
  state={
    show: this.props.show || false
  }
  handleClick(e){
    this.setState({show: !this.state.show});
  }
  render(){
    let { styles: customStyles, value, meta: { valid, touched, error }, ...rest } = this.props;
    customStyles = customStyles || {};
    return (
      <Fragment>
        <PasswordShowInput className={css(styles.base, customStyles.base)} 
          show={this.state.show.toString()} 
          value={value}
          {...rest}/>
        <div className={css(styles.checkWrap)}>
        <input
          className={css(styles.checkinput)}
          type="checkbox"
          name="passwordcheck"
          id="passwordcheck"
          onClick={(e)=>{this.handleClick()}}
          value="1"
        />
        {!this.state.show && (<i className={css(styles.icon).concat(' far fa-eye')}></i>)}
        {this.state.show && (<i className={css(styles.icon).concat(' far fa-eye-slash')}></i>)}
        <label className={css(styles.label)} htmlFor="passwordcheck">{this.state.show ? I18n.t('input.hidepassword') : I18n.t('input.showpassword') }</label>
        </div>
        {touched &&(!valid && <div className={css(styles.error)}>{error}</div>)}
       </Fragment>
    );
  }
};

export default PasswordInput;


// WEBPACK FOOTER //
// ./src/components/inputs/password/PasswordInput.js